import React, { Component } from 'react'
import AddModal from "./Add-People";

const initialEmailFormObject = {
    inputType: "email",
    name: "name",
    inputId: "email",
    value: "",
  };

export class AddPeople extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputFields: [
                { ...initialEmailFormObject },
            ],
            isChecked: false,
        }
    }

handleInputFields = () => {
    this.setState({
      inputFields: [
        ...this.state.inputFields,
        initialEmailFormObject,
      ],
      isChecked: !this.state.isChecked,
    });
    setTimeout(() => {
      this.setState({
        isChecked: false,
      });
    }, 1000);
};
    render() {
        return (
            <div>
                <AddModal
                    inputFields={this.state.inputFields}
                    isChecked={this.state.isChecked}
                    handleInputFields={this.handleInputFields}
                />
            </div>
        )
    }
}

export default AddPeople



// WEBPACK FOOTER //
// ./src/new/Dashboard/Admin/Manage-WorkSheet/Add-People-Modal/index.jsx